import React from 'react';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './main.scss';

const Loading = ({ ...props }) => (
  <div className={styles.spinner} data-testid="loading-spinner" {...props}>
    <Spinner />
  </div>
);

export default Loading;
